import { DivisionListTable } from './components/division-list-table';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useDeleteSeriesMutation } from '../mutations';
import { useSerieDetailsQuery } from '../queries';
import { seriesIdParamSchema } from '~/schemas';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export function Page() {
  const { seriesId } = useParams(seriesIdParamSchema.parse);
  const { data, isLoading } = useSerieDetailsQuery(seriesId);
  const navigate = useNavigate();

  const deleteMutation = useDeleteSeriesMutation();

  async function handleDelete() {
    await toast.promise(deleteMutation.mutateAsync(seriesId), {
      success: 'Serien har tagits bort',
      pending: 'Tar bort serie...',
    });
    navigate(-1);
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text={data.name} subText={data.competition_type.description} />
        <PageLayout.Context
          items={[
            <ContextMenu.Item label="Redigera serie" to={`/series/${seriesId}/edit`} key="edit" />,
            <ContextMenu.Item label="Ta bort" onClick={handleDelete} key="delete" danger />,
          ]}
        />
      </PageLayout.Header>

      <PageLayout.Section>
        <DivisionListTable divisions={data.divisions} isLoading={isLoading} />
      </PageLayout.Section>
    </Fragment>
  );
}
